module.exports = __webpack_public_path__ + "static/media/ganhe_pontos.674b4d49.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/ganhe_pontos.png
// module id = 1948
// module chunks = 12